import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { IDesign } from 'rebus-models';
import { toArray } from 'lodash';

@Component({
  selector: 'app-survey-ranking',
  templateUrl: './survey-ranking.component.html',
  styleUrls: ['./survey-ranking.component.scss']
})
export class SurveyRankingComponent implements OnInit {

  public rate = 0;
  public answerUser: any;

  @Input() public design: IDesign;
  @Input() public idxSurvey: number;
  @Input() public totalSurveys: number;
  @Input() public question: any;
  @Input() public userHasRecord: boolean;
  @Input() public userAnswerSurvey: any;

  @Output() public sendAnswer: EventEmitter<any> = new EventEmitter();

  public ngOnInit() {
    const surveyAnswerUser = toArray(this.userAnswerSurvey)[0];
    if (surveyAnswerUser) {
      const answerUser = toArray(surveyAnswerUser.answers).filter(answer => answer.questionId === this.question.id);
      this.answerUser = answerUser[0].answerUser;
    }
  }

  public onModelChange(rating) {
    this.sendAnswer.emit({
      question: this.question,
      questionId: this.question.id,
      answerUser: rating,
      createdAt: new Date().getTime(),
    });
  }
}
